/**
 * SZ2607 Header — link click tracking (GA4)
 * Config from script#sz-2607-link-track-config (JSON).
 * Same event_name + entry_key → merged; different → split.
 */
(function () {
  var CONFIG_ID = 'sz-2607-link-track-config';
  var INIT_FLAG = 'sz2607LinkTrackInit';
  var ga4MeasurementId = '';
  var ga4ScriptState = 'idle';
  var ga4EventQueue = [];
  var rules = [];

  function isValidGa4MeasurementId(value) {
    return /^G-[A-Z0-9]+$/i.test(String(value || '').trim());
  }

  function parseConfig() {
    var el = document.getElementById(CONFIG_ID);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function flushGa4EventQueue() {
    ga4EventQueue.splice(0).forEach(function (sendFn) {
      sendFn();
    });
  }

  function ensureGa4Gtag(onReady) {
    if (typeof onReady !== 'function') return;

    if (ga4ScriptState === 'ready' && typeof gtag === 'function') {
      onReady();
      return;
    }

    if (!isValidGa4MeasurementId(ga4MeasurementId)) return;

    ga4EventQueue.push(onReady);
    if (ga4ScriptState === 'loading') return;

    ga4ScriptState = 'loading';
    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function () {
        window.dataLayer.push(arguments);
      };

    gtag('js', new Date());
    gtag('config', ga4MeasurementId, { send_page_view: false });

    var script = document.createElement('script');
    script.async = true;
    script.src =
      'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(ga4MeasurementId);
    script.onload = function () {
      ga4ScriptState = 'ready';
      flushGa4EventQueue();
    };
    script.onerror = function () {
      ga4ScriptState = 'idle';
      ga4EventQueue = [];
    };
    document.head.appendChild(script);
  }

  function shopDomain() {
    if (typeof Shopify !== 'undefined' && Shopify.shop) return String(Shopify.shop);
    return window.location.hostname || '';
  }

  function normalizeHref(href) {
    return String(href || '')
      .trim()
      .toLowerCase();
  }

  function linkText(anchor) {
    return String((anchor && (anchor.textContent || anchor.innerText)) || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function inScope(anchor, scope) {
    if (!anchor || !anchor.closest) return false;
    if (scope === 'site_links') {
      return !!(
        anchor.closest('.sz-2607-header__site-links') ||
        anchor.closest('.sz-2607-header__m-sites')
      );
    }
    if (scope === 'explore_featured') {
      return !!anchor.closest('a.sz-2607-nav-explore__featured, .sz-2607-nav-explore__featured');
    }
    // any — must still be inside header (incl. mega / mobile drawer)
    return !!anchor.closest('[data-sz-2607-header]');
  }

  function ruleMatches(rule, anchor) {
    if (!rule || !anchor) return false;
    if (!inScope(anchor, rule.scope || 'any')) return false;

    var urlNeedle = String(rule.match_url || '')
      .trim()
      .toLowerCase();
    var textNeedle = String(rule.match_text || '')
      .trim()
      .toLowerCase();
    if (!urlNeedle && !textNeedle) return false;

    var href = normalizeHref(anchor.getAttribute('href'));
    var text = linkText(anchor);

    if (urlNeedle && href.indexOf(urlNeedle) === -1) return false;
    if (textNeedle && text.indexOf(textNeedle) === -1) return false;
    return true;
  }

  function findRule(anchor) {
    for (var i = 0; i < rules.length; i++) {
      if (ruleMatches(rules[i], anchor)) return rules[i];
    }
    return null;
  }

  function trackClick(rule, anchor) {
    if (!rule || !isValidGa4MeasurementId(ga4MeasurementId)) return;

    var eventName = String(rule.event_name || 'header_link_click').trim() || 'header_link_click';
    var entryKey = String(rule.entry_key || '').trim();
    var href = (anchor && anchor.getAttribute('href')) || '';

    ensureGa4Gtag(function () {
      if (typeof gtag !== 'function') return;
      var params = {
        send_to: ga4MeasurementId,
        entry: entryKey,
        link_url: href,
        shop_domain: shopDomain()
      };
      if (rule.label) params.track_label = String(rule.label);
      gtag('event', eventName, params);
    });
  }

  function onDocumentClick(event) {
    var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!anchor) return;
    if (!anchor.closest('[data-sz-2607-header]')) return;

    var rule = findRule(anchor);
    if (!rule) return;
    trackClick(rule, anchor);
  }

  function init() {
    if (document.documentElement.dataset[INIT_FLAG] === 'true') return;

    var config = parseConfig();
    if (!config) return;

    ga4MeasurementId = String(config.measurement_id || '').trim();
    if (!isValidGa4MeasurementId(ga4MeasurementId)) return;

    rules = Array.isArray(config.rules) ? config.rules : [];
    if (!rules.length) return;

    document.addEventListener('click', onDocumentClick, true);
    document.documentElement.dataset[INIT_FLAG] = 'true';
    ensureGa4Gtag(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    document.documentElement.dataset[INIT_FLAG] = '';
    ga4ScriptState = 'idle';
    ga4EventQueue = [];
    rules = [];
    ga4MeasurementId = '';
    init();
  });
})();
